import { AlertTitle, GridLegacy, Stack } from '@mui/material';
import { IconAlertTriangle, IconCalendarTime } from '@tabler/icons-react';
import Chip, { ChipColor } from 'ui-component/extended/Chip';
import { SxProps, useTheme } from '@mui/system';
import { KitRequestSchema, KitRequestValidationType } from 'types/kitting';
import SegmentButton from 'ui-component/Segment/SegmentButton';
import { formatToShortDate } from 'utils/dates';
import { ValidationAlert } from 'ui-component/ValidationAlert';
import { EstimatedShipDateResult } from 'hooks/useEstimateKitShipDate/types';

type EstimatedShipDateAlertProps = {
  sx?: SxProps;
  estimatedShipDateData: EstimatedShipDateResult;
  savedShipDate: string | null;
  shipPartial: KitRequestSchema['shipPartial'];
  onClick?: () => void;
};

export const EstimatedShipDateAlert = ({
  sx,
  estimatedShipDateData,
  savedShipDate,
  shipPartial,
  onClick,
}: EstimatedShipDateAlertProps) => {
  const theme = useTheme();
  if (estimatedShipDateData.estimatedShipDate === savedShipDate) {
    return null;
  }

  return (
    <ValidationAlert
      variant="outlined"
      severity="warning"
      icon={<IconAlertTriangle />}
      color={theme.palette.warning.dark}
      sx={sx}
    >
      <GridLegacy container direction="row" alignItems="center" spacing={2}>
        <GridLegacy item xs={9}>
          <Stack direction="column">
            <AlertTitle sx={{ fontWeight: 700 }}>
              {shipPartial
                ? `Estimated Ship Date Has Changed (Final Part Will Be Sent ${
                    estimatedShipDateData.latestExpectedStockLot?.expectedBy
                      ? formatToShortDate(
                          estimatedShipDateData.latestExpectedStockLot
                            .expectedBy
                        )
                      : 'TBD'
                  })`
                : 'Estimated Ship Date Has Changed'}
            </AlertTitle>
            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
              <Chip
                variant="filled"
                sx={{ p: 0.5 }}
                label={`Saved: ${
                  savedShipDate ? formatToShortDate(savedShipDate) : 'None'
                }`}
                chipcolor={ChipColor.secondary}
                ChipIcon={IconCalendarTime}
              />
              <Chip
                variant="filled"
                sx={{ p: 0.5 }}
                label={`New: ${
                  estimatedShipDateData.estimatedShipDate
                    ? formatToShortDate(estimatedShipDateData.estimatedShipDate)
                    : 'None'
                }`}
                chipcolor={ChipColor[KitRequestValidationType.WARNING]}
                ChipIcon={IconCalendarTime}
              />
            </Stack>
          </Stack>
        </GridLegacy>
        <GridLegacy item xs={3}>
          <SegmentButton
            variant="contained"
            startIcon={<IconCalendarTime />}
            color="warning"
            onClick={onClick}
            fullWidth
            sx={{ color: 'white' }}
          >
            Update Ship Date
          </SegmentButton>
        </GridLegacy>
      </GridLegacy>
    </ValidationAlert>
  );
};

export default EstimatedShipDateAlert;
